import EvaluationAPI from "../../api/evaluations";
import types from "../mutation-types";


export const state = {
    evaluations: [],
    meta: {
        count: 0,
        current_page: 1,
        page_size: 25,
        reports: {
            // unknown: 0,
            // total_cost: 0,
            // total_duration: 0
        }
    },
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isDeleting: false,
        isUpdating: false,

        // reports
        isReportFetching: false,
    },

    // reports
    reports: [],
    meta_report:{
        count: 0,
        current_page: 1,
        page_size: 25,
        reports: {
            // unknown: 0,
            // total_cost: 0,
            // total_duration: 0
        }
    }
};

// list of getters
const getters = {
    getUIFlags(_state){
        return _state.uiFlags;
    },
    getMeta(_state){
        return _state.meta;
    },
    getEvaluations(_state){
        return _state.evaluations;
    },
    getMetaReport(_state){
        return _state.meta_report;
    },
    getReports(_state){
        return _state.reports;
    },

}


// actions list
const actions = {
    fetchEvaluations: async function({commit,state},query){
        commit(types.SET_EVALUATION_UI_FLAG,{isFetching: true});
        try {
                // commit(types.SET_EVALUATIONS, demoData);
            const response = await EvaluationAPI.getEvaluationsList(query);
            const newData = response.data?.data || [];
            const meta = {
                ...state.meta,
                ...(response.data?.meta || {})
            };
             // if page = 1, make empty the list
            if (query.page === 1) {
                commit(types.SET_EVALUATIONS, newData);
            }else{
                 // Append to existing list
                const combined = [...state.evaluations, ...newData];
                commit(types.SET_EVALUATIONS, combined);
            }
             // Save pagination metadata
            commit(types.SET_EVALUATIONS_META, meta);

            commit(types.SET_EVALUATION_UI_FLAG,{isFetching: false});
        } catch (error) {
            console.log(error);
            commit(types.SET_EVALUATION_UI_FLAG,{isFetching: false});
        }
    },
    filterEvaluations: async function({commit,state},query){
        commit(types.SET_EVALUATION_UI_FLAG,{isFetching: true});
        try {
                // commit(types.SET_EVALUATIONS, demoData);
            const response = await EvaluationAPI.getEvaluationsFilterList(query);
            const newData = response.data?.data || [];
            const meta = {
                ...state.meta,
                ...(response.data?.meta || {})
            };
             // if page = 1, make empty the list
            if (query.page === 1) {
                commit(types.SET_EVALUATIONS, newData);
            }else{
                 // Append to existing list
                const combined = [...state.evaluations, ...newData];
                commit(types.SET_EVALUATIONS, combined);
            }
             // Save pagination metadata
            commit(types.SET_EVALUATIONS_META, meta);

            commit(types.SET_EVALUATION_UI_FLAG,{isFetching: false});
        } catch (error) {
            console.log(error);
            commit(types.SET_EVALUATION_UI_FLAG,{isFetching: false});
        }
    },

    createEvaluation: async function({commit,state},payload){
        commit(types.SET_EVALUATION_UI_FLAG,{isCreating: true});
        try {
            const {data} = await EvaluationAPI.createEvaluation(payload);
            commit(types.SET_EVALUATION_CREATE,data);
            commit(types.SET_EVALUATION_UI_FLAG,{isCreating: false});
            return data;
        } catch (error) {
            console.log(error);
            commit(types.SET_EVALUATION_UI_FLAG,{isCreating: false});
            throw error;
        }
    },
    updateEvaluationById: async function({commit,state},{evaluation_id,payload}){
        commit(types.SET_EVALUATION_UI_FLAG,{isUpdating: true});
        try {
            const {data} = await EvaluationAPI.updateEvaluationById(evaluation_id,payload);
            commit(types.SET_EVALUATION_UPDATE,data);
            commit(types.SET_EVALUATION_UI_FLAG,{isUpdating: false});
            return data;
        } catch (error) {
            console.log(error);
            commit(types.SET_EVALUATION_UI_FLAG,{isUpdating: false});
            throw error;
        }
    },
    deleteEvaluationById: async function({commit,state},{evaluation_id}){
        commit(types.SET_EVALUATION_UI_FLAG,{isDeleting: true});
        try {
            const {data} = await EvaluationAPI.deleteEvaluationById(evaluation_id);
            commit(types.SET_EVALUATION_DELETE,evaluation_id);
            commit(types.SET_EVALUATION_UI_FLAG,{isDeleting: false});
            return data;
        } catch (error) {
            console.log(error);
            commit(types.SET_EVALUATION_UI_FLAG,{isDeleting: false});
            throw error;
        }
    },

    // reports
    getEvaluationReports: async function({commit,state},query){
        commit(types.SET_EVALUATION_UI_FLAG,{isReportFetching: true});
        try {
                // commit(types.SET_EVALUATION_REPORTS, demoData);
            const response = await EvaluationAPI.getEvaluationReports(query);
            const newData = response.data?.data || [];
            const meta = {
                ...state.meta_report,
                ...(response.data?.meta || {})
            };
             // if page = 1, make empty the list
            if (query.page === 1) {
                commit(types.SET_EVALUATION_REPORTS, newData);
            }else{
                 // Append to existing list
                const combined = [...state.reports, ...newData];
                commit(types.SET_EVALUATION_REPORTS, combined);
            }
             // Save pagination metadata
            commit(types.SET_EVALUATION_REPORT_META, meta);

            commit(types.SET_EVALUATION_UI_FLAG,{isReportFetching: false});
        } catch (error) {
            console.log(error);
            commit(types.SET_EVALUATION_UI_FLAG,{isReportFetching: false});
        }
    },
    getEvaluationReportsFilter: async function({commit,state},query){
        commit(types.SET_EVALUATION_UI_FLAG,{isReportFetching: true});
        try {
                // commit(types.SET_EVALUATION_REPORTS, demoData);
            const response = await EvaluationAPI.getEvaluationReportsFilterList(query);
            const newData = response.data?.data || [];
            const meta = {
                ...state.meta_report,
                ...(response.data?.meta || {})
            };
             // if page = 1, make empty the list
            if (query.page === 1) {
                commit(types.SET_EVALUATION_REPORTS, newData);
            }else{
                 // Append to existing list
                const combined = [...state.reports, ...newData];
                commit(types.SET_EVALUATION_REPORTS, combined);
            }
             // Save pagination metadata
            commit(types.SET_EVALUATION_REPORT_META, meta);

            commit(types.SET_EVALUATION_UI_FLAG,{isReportFetching: false});
        } catch (error) {
            console.log(error);
            commit(types.SET_EVALUATION_UI_FLAG,{isReportFetching: false});
        }
    },
}


// list of mutations
const mutations = {
    // mutate UI flags
    [types.SET_EVALUATION_UI_FLAG](_state, data) {
        _state.uiFlags = {
          ..._state.uiFlags,
          ...data,
        };
    },

    [types.SET_EVALUATIONS]($state, data) {
        $state.evaluations = data;
    },
    [types.SET_EVALUATIONS_META]($state, meta) {
        $state.meta = {
            ...meta,
            count: meta.count || 0,
            current_page: meta.current_page || 1,
            page_size: meta.page_size || 15
        };
    },


    [types.SET_EVALUATION_CREATE]($state, data) {
        $state.evaluations.unshift(data)
    },

    [types.SET_EVALUATION_UPDATE]($state, data) {
        const index = $state.evaluations.findIndex(el => el.id === data.id);
        if (index !== -1) {
            // Replace existing coupon
            $state.evaluations.splice(index, 1, data);
        } else {
            // If not found, add the new coupon
            $state.evaluations.push(data);
        }
    },
    [types.SET_EVALUATION_DELETE]($state, evaluation_id) {
        const index = $state.evaluations.findIndex(el => el.id === evaluation_id);
        if (index !== -1) {
            $state.evaluations.splice(index, 1);
        }
    },


    [types.SET_EVALUATION_REPORTS]($state, data) {
        $state.reports = data;
    },
    [types.SET_EVALUATION_REPORT_META]($state, meta) {
        $state.meta_report = {
            ...meta,
            count: meta.count || 0,
            current_page: meta.current_page || 1,
            page_size: meta.page_size || 15
        };
    },



}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}